module.exports = __webpack_public_path__ + "static/media/nyt-franklin-500-normal.728e9527.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nyt-franklin-500-normal.woff
// module id = 280
// module chunks = 0